/**
 *
 * Button
 *
 */
import React, { ButtonHTMLAttributes, ReactNode, memo } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

// Define props for the button component
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: string;
  titleColor?: string;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string; // Additional class names for styling
}

export const Button: React.FC<ButtonProps> = memo(props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  return (
    <Div
      variant={props.variant}
      titleColor={props.titleColor}
      onClick={props.onClick}
      className={props.className}
      disabled={props.disabled}
    >
      {props.children}
    </Div>
  );
});

// Define button styles based on props

const Div = styled.button<ButtonProps>`
  background-color: ${props => props.variant || 'black'};
  color: ${props =>
    props.titleColor || 'white'}; /* Title color with fallback */
  font-size: 12px;
  font-family: 'Nunito', sans-serif;
  font-weight: 400;
  width: 171px;
  height: 50px;
  border-radius: 30px;
  border: none;
`;
